<template>
  <div class="row mx-3 my-5">
    <div class="col-12">
    <div class="mb-3">
      <b-btn class="mr-3" variant="primary" ><a href="/temporarywarehouselist/6/index" class="buttonLink">Lager 2</a></b-btn>
      <b-btn variant="primary"><a href="/temporarywarehouselist/13/index" class="buttonLink">Lager 6</a></b-btn>
    </div>
      <div class="card">
        <div class="card-body">
          <div class="card-title d-flex">
            <h4 class="mr-auto">Liste {{ vendorName }}</h4>
          </div>
          <table class="table">
            <thead>
            <tr>
              <th>Händler</th>
              <th>EAN</th>
              <th>Zustand</th>
              <th>Anzahl</th>
              <th>Ort</th>
              <th>Kommentar</th>
              <th>Benutzer</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in temporaryWarehouseItems" :key="item.id">
              <td>{{ item.vendorId }}</td>
              <td>{{ item.ean }}</td>
              <td>{{ getConditionLabel(item.condition) }}</td>
              <td v-if="authorization.shipping_manager === true">
                <click-to-edit-component
		                :value="String(item.quantity)"
		                @input="item.quantity = $event"
                    :data-id="item.id"
                    data-path="/temporarywarehouselist/quantity">
                </click-to-edit-component>
              </td>
              <td v-else>{{ item.quantity }}</td>
              <td>{{ item.stockyard }}</td>
              <td>{{ item.comment }}</td>
              <td>{{ item.user }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickToEditComponent from "./ClickToEditComponent.vue";

export default {
	components: {ClickToEditComponent},
  props: {
    userRole: {
      type: String,
      required: true
    },
    vendorName: {
      type: String,
      required: true
    },
    passedTemporaryWarehouseItems: {
      type: Array,
      required: true
    }
  },
  data() {
		return {
			authorization: {},
			temporaryWarehouseItems: [],
		};
	},
  methods: {
    getConditionLabel(condition) {
      return condition === 1 ? "NEU" : condition === 2 ? "SH" : "SHY";
    }
  },
  created() {
	  axios.get("/user/authorization").then(response => {
		  this.authorization = response.data;
	  });

  },
  mounted() {
	  this.temporaryWarehouseItems = this.passedTemporaryWarehouseItems;
  }
};
</script>

<style scoped>
.buttonLink {
  color: white;
  text-decoration: none;
}
</style>